import type { Theme } from "@mui/material";

/** Shared Tabs styling: campaign listing, shipment inventory, and similar list screens. */
export function listingStatusTabsStyles(theme: Theme) {
  const accent =
    theme.palette.customColors?.purple ?? theme.palette.primary.main;
  return {
    borderBottom: 1,
    borderColor: "divider",
    "& .MuiTabs-flexContainer": { flexWrap: "nowrap" },
    "& .MuiTab-root": {
      textTransform: "none",
      fontWeight: 600,
      fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
      minHeight: { xs: 40, sm: 48 },
      py: { xs: 0.75, sm: 1 },
      px: { xs: 0.75, sm: 1.25 },
    },
    "& .Mui-selected": {
      color: accent,
      fontWeight: 600,
      fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.875rem" },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: accent,
      height: 3,
    },
  };
}
